import React from 'react'
import image1 from '../images/babyshower1.jpeg'
import image2 from '../images/babyshower2.jpeg'
import image3 from '../images/babyshower3.jpeg'
import image4 from '../images/babyshower4.jpeg'
import image5 from '../images/babyshower5.jpeg'
import image6 from '../images/babyshower6.jpeg'

export default function BabyShowers() {
  return (
    <div className='sub-gallery-images'>
      <img src={image1} alt='photo' className='sub-gallery-image'/>
      <img src={image2} alt='photo' className='sub-gallery-image'/>
      <img src={image3} alt='photo' className='sub-gallery-image'/>
      <img src={image4} alt='photo' className='sub-gallery-image'/>
      <img src={image5} alt='photo' className='sub-gallery-image'/>
      <img src={image6} alt='photo' className='sub-gallery-image'/>
    </div>
  )
}
